import { isTextEmpty } from '~/_shared/utils/text/text.helpers';

export const validate2FaLoginForm = (code: string): boolean => {
  return !isTextEmpty(code) && code.length === 6;
};
